import { useNavigation } from '@react-navigation/native'
import React, { useState } from 'react'
import { styled } from 'styled-components/native'
import { v4 as uuidv4 } from 'uuid'

import { StyledBodyXsSteps } from 'features/bonification/pages/BonificationNames'
import {
  qfBonificationActions,
  useQFBonification,
} from 'features/bonification/store/qfBonificationStore'
import { UseNavigationType } from 'features/navigation/navigators/RootNavigator/types'
import { getSubscriptionHookConfig } from 'features/navigation/navigators/SubscriptionStackNavigator/getSubscriptionHookConfig'
import { AccessibilityRole } from 'libs/accessibilityRole/accessibilityRole'
import { RadioSelector } from 'ui/components/radioSelector/RadioSelector'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Button } from 'ui/designSystem/Button/Button'
import { PageWithHeader } from 'ui/pages/PageWithHeader'
import { Typo } from 'ui/theme'
import { setTextSemantic } from 'ui/theme/typographyAttrs/setTextSemantic'

export type Title = 'Madame' | 'Monsieur'

enum FormValues {
  MADAM = 'Madame',
  MISTER = 'Monsieur',
}

export const BonificationTitle = () => {
  const { navigate } = useNavigation<UseNavigationType>()

  const storedLegalRepresentative = useQFBonification()
  const { setTitle: storeTitle } = qfBonificationActions

  const titleID = uuidv4()
  const titleLabel = 'Civilité'
  const [title, setTitle] = useState<Title | null>(storedLegalRepresentative.title ?? null)
  const disabled = !title

  const saveTitleAndNavigate = () => {
    if (title) storeTitle(title)
    navigate(...getSubscriptionHookConfig('BonificationBirthDate'))
  }
  return (
    <PageWithHeader
      shouldLimitWidth
      title="Informations"
      scrollChildren={
        <React.Fragment>
          <StyledBodyXsSteps>Étape 2 sur 5</StyledBodyXsSteps>
          <Typo.Title3 {...setTextSemantic('h2')}>
            Quelle est la civilité de ton représentant légal&nbsp;?
          </Typo.Title3>
          <SelectorContainer
            gap={5}
            accessibilityRole={AccessibilityRole.RADIOGROUP}
            accessibilityLabelledBy={titleID}>
            <RadioSelector
              radioGroupLabel={titleLabel}
              label="Madame"
              checked={title === FormValues.MADAM}
              onPress={() => setTitle(FormValues.MADAM)}
            />
            <RadioSelector
              radioGroupLabel={titleLabel}
              label="Monsieur"
              checked={title === FormValues.MISTER}
              onPress={() => setTitle(FormValues.MISTER)}
            />
          </SelectorContainer>
        </React.Fragment>
      }
      fixedBottomChildren={
        <Button
          type="submit"
          wording="Continuer"
          accessibilityLabel="Continuer vers la date de naissance"
          onPress={saveTitleAndNavigate}
          disabled={disabled}
        />
      }
    />
  )
}

const SelectorContainer = styled(ViewGap)(({ theme }) => ({
  marginVertical: theme.designSystem.size.spacing.xl,
}))
